import { render, staticRenderFns } from "./SalesOrderPreview.vue?vue&type=template&id=7c73c5a1"
import script from "./SalesOrderPreview.vue?vue&type=script&lang=js"
export * from "./SalesOrderPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports